import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/base-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/contentful-ui/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["EndeavorEmbed"] */ "/app/node_modules/@stadionhq-v3/endeavor-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/football-ui/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["StreamVideoPlayer"] */ "/app/node_modules/@stadionhq-v3/stream-ui/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/Leeds-United-Teams.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/localized-date/localizedDate.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/analytics-page-view/analyticsPageView.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/article-card-renderer/articleCardRenderer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/content-block-renderer/blocks/accordion-block/accordionBlock.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/content-block-renderer/blocks/article-promo-block/articlePromoBlock.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/gamification-entry/gamificationEntry.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/text-with-image-block/textWithImageBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/gateway-carousel-block/gatewayCarouselBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/promo-carousel-block/promoCarouselBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/news-carousel-block/newsCarouselBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/blocks/tabbed-carousel/tabbedCarouselBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/contentful-rich-text-render/contentfulRichTextRender.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/stream-session-wrapper/streamSessionWrapper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StreamVideoAndOverlayWrapper"] */ "/app/src/components/helpers/stream-video-and-overlay-wrapper/streamVideoAndOverlayWrapper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/article-subscription-barrier/articleSubscriptionBarrier.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/broadcasters-wrapper/broadcastersWrapper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/referee-appointments-search/refereeAppointmentsSearch.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/loading-template/loadingTemplate.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/article-template/articleTemplate.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TextButton"] */ "/app/src/components/v3/atoms/button/variants/text-button/text-button.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/molecules/video-cards/videoCard.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/fixture-card-slotted/fixtureCardSlotted.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/promo-carousel-block/promoCarouselBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/fixture-summary-block/fixtureSummaryBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/related-content/relatedContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/footer-block/footerBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollerBlock"] */ "/app/src/components/v3/organisms/scroller-block/scrollerBlock.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/table-block/tableBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/text-block/textBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/text-with-image-block/textWithImageBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/promo-block/promoBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/gateway-carousel/gatewayCarousel.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/stats-block/statsBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/news-carousel/newsCarousel.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/helpers/content-block-renderer/contentBlockRenderer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/video-blocks/videoBlocks.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/video-embed/videoEmbed.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/templates/articles/article.component.tsx");
